import { DayOfWeek } from 'generated/graphql-types';

export interface DaysOfWeekReportParameterValue {
   values: DayOfWeek[][];
   // includeMonday: boolean;
   // includeTuesday: boolean;
   // includeWednesday: boolean;
   // includeThursday: boolean;
   // includeFriday: boolean;
   // includeSaturday: boolean;
   // includeSunday: boolean;
}

export const defaultDaysOfWeekParameter: DaysOfWeekReportParameterValue = {
   values: [
      [
         DayOfWeek.Monday,
         DayOfWeek.Tuesday,
         DayOfWeek.Wednesday,
         DayOfWeek.Thursday,
         DayOfWeek.Friday,
         DayOfWeek.Saturday,
         DayOfWeek.Sunday,
      ],
   ],
   // includeMonday: true,
   // includeFriday: true,
   // includeSaturday: true,
   // includeSunday: true,
   // includeThursday: true,
   // includeTuesday: true,
   // includeWednesday: true,
};
